export default __webpack_public_path__ + "static/media/03.54d73b96.jpg";